import React, { useEffect, useState } from 'react';
import { Container, Grid, Card, CardMedia, CardContent, Typography, List, ListItem, ListItemText, Button, Box } from '@mui/material';
import { getProducts, deleteProduct } from '../api/products';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const ProductList = () => {
    const [products, setProducts] = useState([]);
    const navigate = useNavigate();

    const fetchProducts = async () => {
        try {
            const response = await getProducts();
            setProducts(response.data.products || response.data);
        } catch (error) {
            console.error('Error fetching products:', error);
            setProducts([]);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleEdit = (productId) => {
        navigate(`/admin/products/edit/${productId}`);
    };

    const handleDelete = async (productId) => {
        if (window.confirm('Are you sure you want to delete this product?')) {
            try {
                await deleteProduct(productId);
                fetchProducts(); // Refresh list after deletion
            } catch (error) {
                console.error('Error deleting product:', error);
            }
        }
    };

    if (!Array.isArray(products)) {
        return <Typography>Loading products...</Typography>;
    }

    return (
        <Container sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>Products</Typography>
            <Grid container spacing={4}>
                {products.map((product) => (
                    <Grid item key={product._id} xs={12} sm={6} md={4}>
                        <Card>
                            {product.image && (
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={product.image.url}
                                    alt={product.title}
                                />
                            )}
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    {product.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {product.description}
                                </Typography>
                                <Typography variant="h6" sx={{ mt: 2 }}>
                                    ${product.price}
                                </Typography>
                                {product.features && (
                                    <List>
                                        {product.features.map((feature, index) => (
                                            <ListItem key={index}>
                                                <ListItemText primary={feature} />
                                            </ListItem>
                                        ))}
                                    </List>
                                )}
                                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                                    <Button 
                                        variant="contained" 
                                        color="primary"
                                        startIcon={<EditIcon />}
                                        onClick={() => handleEdit(product._id)}
                                    >
                                        Edit
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="error"
                                        startIcon={<DeleteIcon />}
                                        onClick={() => handleDelete(product._id)}
                                    >
                                        Delete
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default ProductList;
